import React from 'react'

import { Row, Col } from '_zari/core'

import * as Portlets from './portlets'

const ReporteDetracciones = () => {
  const tablaRef = React.useRef({})

  return (
    <>
      <Row>
        <Col md={12}>
          <Portlets.ListaVentasPortlet tablaRef={tablaRef} />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Portlets.ReportesPortlet tablaRef={tablaRef} />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ReporteDetracciones)
